import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var alertComponentName = 'QuantumAlert';
export function getAlertUtilityClass(slot) {
    return generateUtilityClass(alertComponentName, slot);
}
export var alertClasses = generateUtilityClasses(alertComponentName, [
    'root',
    'icon',
    'content',
    'title',
    'message',
    'action',
]);
